import axios from "axios";
import localforage from "localforage";

export function request(url, method, data, no_token = false, fullUrl = null) {
    return new Promise((resolve, reject) => {
        localforage.getItem("jwt").then((user_token) => {
            var requestOptions = {
                method: method ? method : 'GET',
                url: (fullUrl ? url : process.env.REACT_APP_BACKEND + url)
            };
            if (data) {
                requestOptions['data'] = check_data(data);
            }


            var myHeaders = {};
            if (user_token) {
                myHeaders['Authorization'] = `Bearer ${user_token}`;
            }
            myHeaders['Content-Type'] = "application/json";
            requestOptions['headers'] = myHeaders;
            axios(requestOptions).then(response => {
                resolve(response.data)
            }).catch(error => {
                reject()
            })
        });
    });
};

export const check_data = (data) => {
    for (const key in data) {
        if (data[key] === undefined)
            data[key] = '';
    }
    return JSON.stringify(data);
}
